import React, { useEffect, useState } from "react";
import { HashLink as Link } from "react-router-hash-link";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

const FeatureV1 = () => {
  const [services, setServices] = useState([]);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await fetch("https://eventscons.com/eventbackendnew/api/service-details");
        const result = await response.json();

        if (result?.status && Array.isArray(result?.data)) {
          setServices(result.data);
        }
      } catch (error) {
        console.error("Services API fetch error:", error);
      }
    };

    fetchServices();
  }, []);

  return (
    <section
      className="features-section-two"
      style={{ padding: "80px 0", backgroundColor: "#f9f7f4" }}
    >
      <div className="auto-container">
        {/* Header Section */}
        <div className="row align-items-end mb-5">
          <div className="col-lg-8 col-md-12">
            <div className="sec-title" style={{ marginBottom: "0" }}>
              <h6
                style={{
                  color: "#b21e35",
                  fontWeight: "600",
                  textTransform: "none",
                  textAlign: "left",
                  fontSize: "20px",
                }}
              >
                Services
              </h6>

              <h2 className="mainheadingfont" 
                style={{
                  fontSize: "40px",
                  textAlign: "left",
                  fontWeight: "700",
                  marginTop: "10px",
                  marginBottom: "0px",
                }}
              >
                We Specialize In The <br />
                Following <span style={{ color: "#b21e35" }}>Case Studies</span>
              </h2>
            </div>
          </div>

          <div className="col-lg-4 col-md-12 text-lg-end mt-4 mt-lg-0">
            <Link
              to="/up/event"
              className="theme-btn"
              style={{
                backgroundColor: "#000",
                color: "#fff",
                padding: "12px 30px",
                borderRadius: "0px",
                textDecoration: "none",
                display: "inline-block",
                fontSize: "17px",
              }}
            >
              Discover More »
            </Link>
          </div>
        </div>

        {/* Slider Section */}
        <div className="homeslider-one"> 
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={25}
          slidesPerView={1}
          loop={services.length > 3}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true }}
          breakpoints={{
            576: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1200: {
              slidesPerView: 3,
            },
          }}
          style={{ paddingBottom: "50px" }}
        >
          {services.map((item) => (
            <SwiperSlide key={item.id}>
              <a
                href={item?.service_link}
                style={{ textDecoration: "none", display: "block" }}
              >
                <div
                  className="service-card"
                  style={{
                    position: "relative",
                    borderRadius: "20px",
                    overflow: "hidden",
                    height: "400px",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                  }}
                >
                  <img
                    src={item?.service_image}
                    alt={item?.service_name}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />

                  <div
                    style={{
                      position: "absolute",
                      bottom: "0",
                      left: "0",
                      right: "0",
                      height: "50%",
                      background:
                        "linear-gradient(to top, rgba(0,0,0,0.8), transparent)",
                      display: "flex",
                      alignItems: "flex-end",
                      padding: "30px",
                      justifyContent: "space-between",
                    }}
                  >
                    <h3
                      style={{
                        color: "#fff",
                        margin: "0",
                        fontSize: "24px",
                        fontWeight: "600",
                      }}
                    >
                      {item?.service_name}
                    </h3>

                    <div
                      style={{
                        width: "45px",
                        height: "45px",
                        backgroundColor: "#fff",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        flexShrink: 0,
                      }}
                    >
                      <span
                        style={{
                          color: "#b21e35",
                          fontSize: "20px",
                          fontWeight: "bold",
                        }}
                      >
                        ↗
                      </span>
                    </div>
                  </div>
                </div>
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
        </div>
      </div>
    </section>
  );
};

export default FeatureV1;